// 纯 JS 函数，跟 Vue 没有任何关系
export function formatDict(id, list) {
  if (!id || !list) return '未知'
  const item = list.find(item => item.id === id)
  return item ? item.name : '未知'
}
